/**
 * Tags links that have an offsite URL.
 */

/* global ceNetworkDomain */

class offSiteLinks {
  constructor() {
    this.initialize();
  }

  initialize() {
    if (typeof ceNetworkDomain !== 'undefined') {
      const allLinks = document.querySelectorAll('a');

      if (allLinks) {
        const skipClasses = [
          'nav__logo-link',
          'footer__logo-link',
          'social-item__link',
          'nav__seal-link',
          'news-topper__feature-link',
          'news-topper__latest-item-link',
          'news-home-press__link',
          'news-home-around-cornell__item-link',
          'ce-block__card-list-item-link',
          'ce-block__people-list-art-link',
          'tease__art__link',
          'program-table__program-degree-link',
          'ce-block__program-degree-link',
        ];

        const retargetClasses = {
          tease__hgroup: '.tease__h-underline',
        };

        allLinks.forEach(link => {
          // Check to see if the link classList has any skipClasses classes.
          if (skipClasses.some(className => link.classList.contains(className))) {
            return;
          }

          const href = link.href;

          if (!href) {
            return;
          }

          if (!href.includes('http')) {
            return;
          }

          if (href.includes(ceNetworkDomain)) {
            return;
          }

          const excludeOnlyChildTags = ['img', 'svg', 'figure', 'picture'];
          const childNodes = link.childNodes;
          const firstChild = childNodes[0];
          const firstChildNodeName = firstChild ? firstChild.nodeName.toLowerCase() : '';

          if (childNodes.length === 1 && excludeOnlyChildTags.includes(firstChildNodeName)) {
            return;
          }

          // Check to see if the link classList has any retargetClasses classes.
          if (Object.keys(retargetClasses).some(className => link.classList.contains(className))) {
            const maybeNewTarget = link.querySelector(
              retargetClasses[
                Object.keys(retargetClasses).find(className => link.classList.contains(className))
              ],
            );

            if (maybeNewTarget) {
              link = maybeNewTarget;
            }
          }

          const arrowSpan = document.createElement('span');
          const arrowSpanText = document.createElement('span');
          arrowSpan.classList.add('offsite-link__arrow');
          arrowSpan.setAttribute('aria-hidden', 'true');
          arrowSpan.innerHTML = '&nbsp;&nearr;';
          arrowSpanText.classList.add('offsite-link__text');
          arrowSpanText.innerHTML = link.innerHTML;

          link.innerHTML = '';
          link.appendChild(arrowSpanText);
          link.classList.add('offsite-link');
          link.appendChild(arrowSpan);
        });
      }
    }
  }
}

export default offSiteLinks;
